import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useAppNotification } from '@feature/utils';

import { TranslationForm } from './TranslationForm';
import { useTranslationCreate } from './model/TranslationQuery';
import { TranslationSchema, defaultTranslationValues, translationSchema } from './model/TranslationSchema';

export function TranslationCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useTranslationCreate();
  const navigate = useNavigate();
  const notification = useAppNotification();

  const onSubmit = (values: TranslationSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newTranslation => {
        notification.success();
        navigate({ to: '/author/translation/$translationId', params: { translationId: String(newTranslation.id) } });
      },
    });
  };

  return (
    <TranslationForm
      title={t('translations.form.title.create')}
      schema={translationSchema}
      defaultValues={defaultTranslationValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
      showWosFields={false}
      showScopusFields={false}
    />
  );
}
